module.exports = __webpack_public_path__ + "static/garnishings01-b38e36573b8e0a027adb120177ba18fc.jpg";